import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-expanded"]
const _hoisted_2 = ["aria-labelledby"]

import {ref, Ref} from 'vue';

    type CollapsibleProps = {
        id: string;
    };

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Collapsible',
  props: {
    id: {}
  },
  setup(__props: any) {

    

    const isOpen = ref(false);
    const contentRef: Ref<HTMLDivElement | null> = ref(null);

    function toggleCollapsible() {
        isOpen.value = !isOpen.value;

        if (contentRef.value) {
            if (isOpen.value) {
                contentRef.value.style.maxHeight = `${contentRef.value.scrollHeight}px`;
            } else {
                contentRef.value.style.maxHeight = '0px';
            }
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      id: _ctx.id,
      type: "button",
      class: _normalizeClass({'collapsible-header': true, 'open': isOpen.value}),
      "aria-expanded": isOpen.value,
      onClick: toggleCollapsible
    }, [
      _renderSlot(_ctx.$slots, "header"),
      _createVNode(_component_joy_icon, {
        name: "chevron-down",
        class: "chevron"
      })
    ], 10, _hoisted_1),
    _createElementVNode("div", {
      ref_key: "contentRef",
      ref: contentRef,
      role: "region",
      class: _normalizeClass({'collapsible-content': true, 'open': isOpen.value}),
      "aria-labelledby": _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 10, _hoisted_2)
  ]))
}
}

})